import { env } from 'config';
import { DefaultPaymentTypeCode } from 'enums';
import {
  MonitoringDataItem,
  BankAggregatedMonitoringItem,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/orders-monitoring`;

const getPayinAsTrader = async (
  params: QueryParams,
): Promise<{
  monitoringData: MonitoringDataItem[];
  availablePaymentTypes: DefaultPaymentTypeCode[];
}> => {
  const response = await apiUtils.getWithQueryParams(
    `${url}/trader/payin`,
    params,
  );
  return response?.data;
};

const getPayoutAsTrader = async (
  params: QueryParams,
): Promise<{
  bankMonitoringData: BankAggregatedMonitoringItem[];
  amountMonitoringData: MonitoringDataItem[];
  availablePaymentTypes: DefaultPaymentTypeCode[];
}> => {
  const response = await apiUtils.getWithQueryParams(
    `${url}/trader/payout`,
    params,
  );
  return response?.data;
};

export const ordersMonitoringApi = {
  getPayinAsTrader,
  getPayoutAsTrader,
};
